import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Dominio } from "src/app/model/dominio-operacao.model";
import { AditivoOperacaoCreditoLivre, OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { AditivoPopupComponent } from "../../../aditivo-popup.component";
import { AditivoOperacaoCreditoLivreService } from "../../../aditivo.service";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";

@Component({
    selector: 'aba-aditivos',
    templateUrl: 'aba-aditivos.component.html',
    standalone: false
})
export class AbaAditivosComponent implements OnChanges {

  @Input()
  public operacao:OperacaoGarantida;

  @Input()
  public dadosDominio: Dominio;

  @Output() aditivoCancelado = new EventEmitter<boolean>();

  public aditivos: AditivoOperacaoCreditoLivre[];

  constructor(
    private aditivoService: AditivoOperacaoCreditoLivreService,
    private loadingService: BnLoadingService,
    private ngbModal: NgbModal) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.aditivos = this.operacao.detalhe.aditivos;
  }

  visualizarAditivo(idAditivo: number) {

    this.loadingService.bloqueiaTela();

    this.aditivoService.findById(idAditivo).subscribe(resp => {

      this.loadingService.liberaTela();

      const modalRef = this.ngbModal.open(AditivoPopupComponent, {
        windowClass: 'modal-dialog-l',
        backdrop: 'static'
      });

      modalRef.componentInstance.aditivo = resp;
      modalRef.componentInstance.dadosDominio = this.dadosDominio;

      modalRef.result.then((resultado) => {
        if (resultado == 'aditivo-cancelado') {
          this.aditivoCancelado.emit(true);                    
        }
      }, (error) => {
        // so fechou o modal - nada a fazer
      });
    });
  }
}